var _path, _line, _rect, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleteGoalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_14_Goals_Completion",
    "data-name": "14 Goals Completion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 73.477,
    height: 65.149,
    viewBox: "0 0 73.477 65.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7850",
    "data-name": "Path 7850",
    d: "M99.177,40H58.17V66.361H99.177L90.39,53.181Z",
    transform: "translate(-25.699 -25.004)",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    "data-name": "Line 127",
    x1: 35.149,
    y1: 61.51,
    transform: "translate(3.18 1.816)",
    fill: "none"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1942",
    "data-name": "Rectangle 1942",
    width: 7.323,
    height: 70.848,
    transform: "matrix(0.868, -0.496, 0.496, 0.868, 0, 3.632)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7851",
    "data-name": "Path 7851",
    d: "M58.17,61.542,69.886,48.361V22L58.17,48.361Z",
    transform: "translate(-25.699 -20.184)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7852",
    "data-name": "Path 7852",
    d: "M33.233,48.361H59.177V22H18.17Z",
    transform: "translate(-14.99 -20.184)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7853",
    "data-name": "Path 7853",
    d: "M74.17,53.181,76.242,40H74.17Z",
    transform: "translate(-29.983 -25.004)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7854",
    "data-name": "Path 7854",
    d: "M42.958,58H38.74l5.543,2.321Z",
    transform: "translate(-20.497 -29.823)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteGoalIcon);
export default __webpack_public_path__ + "static/media/complete-goal-icon.e8b764a1a86d14590bef9a8e9d75f05b.svg";
export { ForwardRef as ReactComponent };